import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon3: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#F3123C"
        d="m7.576 3.004 2.327 3.957c.103.175.311.644.391 1.275.042.327.05.7-.012 1.097A3.946 3.946 0 0 0 11.2 6.8C11.2 4.7 9.56 2.977 7.468 2.8c.033.07.07.137.109.204ZM8.706 8.193 6.986 5.36a3 3 0 0 1-.272-2.56C4.529 2.933 2.8 4.658 2.8 6.768a3.796 3.796 0 0 0 .487 1.864l.009.014c.029.052.058.102.09.152l.607 1.019c.04.084.086.166.135.247l2.382 3.92c.181.3.307.62.376.948l.1-.164a3 3 0 0 0 0-3.136l-.56-.921-1.351-2.225a2.999 2.999 0 0 1 .007-3.126l.098-.164c.07.328.195.649.377.948l1.114 1.833.13.215 1.441 2.372.173.284c.182.3.307.62.377.948l.099-.164a3.017 3.017 0 0 0 .442-1.569c0-.541-.147-1.082-.442-1.567l-.185-.304Z"
      />
      <Path
        fill="#F3123C"
        d="m7 19.6-5.943-9.254a.12.12 0 0 1-.01-.014l-.128-.199a6.847 6.847 0 0 1-.654-1.517A6.57 6.57 0 0 1 .01 6.424C.2 2.827 3.267.004 6.995 0h.01c3.73.006 6.797 2.827 6.986 6.424a6.568 6.568 0 0 1-.914 3.705l-.054.091c-.04.064-.08.129-.123.192l-.065.104L7 19.6Zm0-1.867 4.787-7.37.31-.479a5.662 5.662 0 0 0 .751-1.604 5.582 5.582 0 0 0 .21-1.84C12.895 3.36 10.241.943 7.013.933H6.99C3.76.941 1.105 3.358.942 6.44a5.581 5.581 0 0 0 .221 1.879c.164.555.413 1.082.74 1.565l.057.086.258.39L7 17.733Z"
      />
    </Svg>
  )
}
